import request from '@/utils/request'

// 获取登录验证码
export function recordClientUseVersion(data) {
    return request({
        url: '/common/record_client_user_version',
        method: 'post',
        data
    })
}
